/* eslint-disable arrow-body-style */
import http from '@/utils/http';
import { isEmpty } from '@intelligence/v3/utils/common';
import { DOWNLOAD_TIMEOUT } from '@intelligence/services/download';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import {
  getValidSurgeMetric,
  getSurgeMetricRotationOrderBy,
} from '@intelligence/pages/TopCharts/PCConsoleGames/utils/surgeMetricUtils';
import { normalizePcConsoleTopChartsApiPayload } from '@intelligence/pages/TopCharts/_config/topchartFilterCfg';

import type { IGameType, IBaseResponse, ICommonOption } from '@intelligence/types/common';
import type { AxiosRequestConfig } from 'axios';

// 旧榜单接口，新风格弃用
// export const getTopActiveuserMobile: (payload: any) => Promise<any> = (payload) => {
//   return http({
//     url: '/api/v1/intelligence_pc/pcTopchartsRankMobileAU',
//     method: 'post',
//     data: payload,
//     rawData: true,
//   }) as Promise<any>;
// }

// mobile-active user/revenue/downloads/dataBrain Calibration 四榜单通用接口--宽表数据
export const fetchDataBrainRanks: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/topChartsDataBrainRankList',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchDataBrainRanksCommon: (payload: any, config?: { [key: string]: any }) => Promise<any> = (
  payload,
  config,
) => {
  return http({
    ...config,
    url: '/api/v1/intelligence_pc/topChartsMobileCommonList',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchGameStreamingRanks: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/rank/get_game_streaming', // 调试新接口, youbing
    // url: '/api/v1/intelligence_pc/getGameStreaming',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchTopChartsMaxDate: (payload: any) => Promise<any> = (payload) => {
  return http({
    // url: '/api/v1/intelligence_pc/topChartsMaxDate',
    url: '/api/v1/intelligence_pc/getDefaultDataByDate',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// mobile-active user/revenue/downloads/dataBrain Calibration 四榜单通用接口--折线图数据
// export const fetchDataBrainTrends: (payload: any) => Promise<any> = (payload) => {
//   return http({
//     url: '/api/v1/intelligence_pc/topChartsDataBrainTrend',
//     method: 'post',
//     data: payload,
//     rawData: true,
//   }) as Promise<any>;
// };

export const fetchDataBrainTrendsCommon: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/topChartsMobileCommonTrend',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// mobile-RPD 表格接口
export const fetchTopChartsRpdRankList: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/pcTopChartsRpdRankList',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// mobile-RPD 表格接口-新统一接口，榜单、详情使用同一接口
export const fetchMobileTopChartsRpdList: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/mobile_topcharts_rpd_list',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// mobile-RPD 折线接口
export const fetchTopChartsRpdTrend: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/pcTopChartsRpdTrend',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// mobile-Retention 表格接口
export const fetchTopChartsRetentionRankList: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/topChartsRetentionRankList',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// mobile-Retention 折线接口
export const fetchTopChartsRetentionTrend: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/topChartsRetentionTimeList',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// Mobile Newrelease 表格接口
export const fetchTopChartsMobileNR: (payload: any, config?: { [key: string]: any }) => Promise<any> = (
  payload,
  config,
) => {
  return http({
    ...config,
    url: '/api/v1/intelligence_pc/pcTopchartsMobileNR',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// PC  Newrelease 折线图接口
export const fetchTopChartsPCNRPcuTrend: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/pcTopchartsNRPcuTrend',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// PCConsole Newrelease 表格接口
export const fetchTopChartsPCConsoleNR: (payload: any, config?: { [key: string]: any }) => Promise<any> = (
  payload,
  config,
) => {
  return http({
    ...config,
    url: '/api/v1/intelligence_pc/pcTopchartsPcConsoleNR',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// PCConsole UPcomming 表格接口
export const fetchTopChartsMobileUP: (payload: any, config?: { [key: string]: any }) => Promise<any> = (
  payload,
  config,
) => {
  return http({
    ...config,
    url: '/api/v1/intelligence_pc/pcTopchartsMobileUpcoming',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// PCConsole UPcomming 表格接口
export const fetchTopChartsPCConsoleUP: (payload: any, config?: { [key: string]: any }) => Promise<any> = (
  payload,
  config,
) => {
  return http({
    ...config,
    url: '/api/v1/intelligence_pc/pcTopchartsPcConsoleUP',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// Mobile Newrelease/UPcomming 内嵌表格接口
export const fetchTopChartspotential: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/potential',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

/** 获取引导状态，通过参数区分页面，旧情报接口函数：fetchIsFirstAccessTopChartsPage
 * 1 Topchart第一个榜单落地页下载提示
 * 2 Following管理按钮提示
 * 通过打点接口实现状态悠
 */
export const fetchGuideStatus: (payload?: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/common/guide_status',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 已弃用
// export const getEarliestDate: (payload: any, earliesUrl?: string) => Promise<any> = (payload, earliesUrl) => {
//   return http({
//     url: earliesUrl ? earliesUrl : '/api/v1/intelligence_pc/detail/stats/earliestDate',
//     method: 'post',
//     data: payload,
//     rawData: true,
//   }) as Promise<any>;
// };

export const getNewEarliestDate: (
  payload: any,
  earliesUrl?: string,
  extra?: { [key: string]: any },
) => Promise<any> = (payload, earliesUrl, extra = {}) => {
  // 处理 gamalytic_ 前缀的 metric 参数转换
  const processedPayload = { ...payload };
  // 处理 metric 数组字段
  if (Array.isArray(processedPayload.metric)) {
    const gamalyticMetrics = processedPayload.metric.filter((m: string) => m?.startsWith('gamalytic_'));
    if (gamalyticMetrics.length > 0) {
      processedPayload.data_sources = ['gamalytic'];
    }
  }
  return http({
    url: earliesUrl ? earliesUrl : '/api/v1/intelligence_pc/gameDetail/earliestDate',
    method: 'post',
    data: processedPayload,
    rawData: true,
    ...extra,
  }) as Promise<any>;
};

export const statsRetentionMonthlyTrends: (
  payload: any,
  config?: { [key: string]: any },
) => Promise<any> = (payload, config = {}) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/stats/retention/monthly_trends',
    method: 'post',
    data: payload,
    rawData: true,
    ...config,
  }) as Promise<any>;
};

export const statsRetentionMonthlyEditionShare: (
  payload: any,
  config?: { [key: string]: any },
) => Promise<any> = (payload, config = {}) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/stats/retention/monthly/editionShare',
    method: 'post',
    data: payload,
    rawData: true,
    ...config,
  }) as Promise<any>;
};

export const statsRetentionMonthlyMarketShare: (
  payload: any,
  config?: { [key: string]: any },
) => Promise<any> = (payload, config = {}) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/stats/retention/monthly/marketShare',
    method: 'post',
    data: payload,
    rawData: true,
    ...config,
  }) as Promise<any>;
};

export const statsRetentionLifetime: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/stats/retention/lifetime',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const countryRetentionLifetime: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/stats/retention/lifetimeCountryShare',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const statsActiveuserTrends: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/mobile/detail/stats/trend',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const statsActiveuserEditionTable: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/mobile/detail/stats/editionTable',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const statsActiveuserEditionTrend: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/mobile/detail/stats/editionTrend',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const statsActiveuserMarketTable: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/mobile/detail/stats/market/table',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const statsActiveuserMarketTrend: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/mobile/detail/stats/market/trend',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const statsRPDTrend: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/stats/rpd/trends',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const statsRPDEdition: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/stats/rpd/edition_share',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const statsRPDEditionLine: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/stats/rpd/edition_share_trends',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const statsRPDCountryTable: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/stats/rpd/countriesShare',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const statsRPDCountryTrend: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/stats/rpd/countriesShare/trends',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getGameBasicinfo: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/basic_info',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// Demographics - App 下拉选项
export const getGameBasicinfoNew: (payload: any) => Promise<any> = (payload) => {
  const { page = 1, page_size = 50, entity_type = 'mobile', order = 'desc', order_metric = 'mau', granularity, ...rest } = payload || {};
  return http({
    url: '/api/v1/intelligence_pc/game/mobile/demographic/topcharts',
    method: 'post',
    data: {
      page,
      page_size,
      entity_type,
      order,
      order_metric,
      granularity,
      ...rest,
      // lifetime 粒度不需要时间范围，清空 start_date/end_date
      ...(granularity === 'lifetime' ? { start_date: '', end_date: '' } : {}),
    },
    rawData: true,
  }) as Promise<any>;
};

// mobile详情页demographics下载（数据源sensortower专用）
export const downloadMobileDetailDemographics: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/game/mobile/demographic/detail/download',
    method: 'post',
    data: payload,
    responseType: 'arraybuffer',
    original: true,
    timeout: DOWNLOAD_TIMEOUT,
  }) as Promise<any>;
};

// mobile榜单页demographics下载（数据源sensortower专用）
export const downloadMobileRankDemographics: (payload: any) => Promise<any> = (payload) => {
  const { granularity } = payload || {};
  if (granularity === 'quarter') {
    payload.granularity = 'quarterly';
    payload.start_date = '';
    payload.end_date = '';
  }
  return http({
    url: '/api/v1/intelligence_pc/game/mobile/demographic/topcharts/download',
    method: 'post',
    data: payload,
    responseType: 'arraybuffer',
    original: true,
    timeout: DOWNLOAD_TIMEOUT,
  }) as Promise<any>;
};

export const getGameBasicinfoCombine: (payload: {
  entity_type: 'combine';
  id: string;
  about: 1 | 0;
  similar_game: 1 | 0;
}) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/combine/basic_info',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 从舆情系统获取该游戏是否有舆情权限
export const fetchGameOpinionlimits: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/opinion_pc/game',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getDemographicsAppids: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/demographics/appIds',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 获取推送内容
export const getRainbowApi: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/permission/rainbow',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 真实数据反馈-添加
export const addTrueDataFeedback: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/trueDataFeedbackAdd',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};
// 一键识别
export const onceIdentification: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/ai/search_game_metric',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};
// 真实数据反馈-编辑
export const editTrueDataFeedback: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/trueDataFeedback/historyAlter',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 获取反馈历史记录
export const getTrueDataFeedbackHistory: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/get/trueDataFeedback/history',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 真实数据反馈-获取
export const getTrueDataFeedbackHistoryNew: (payload: any, config?: AxiosRequestConfig) => Promise<any> = (
  payload,
  config,
) => {
  return http({
    ...config,
    url: '/api/v1/intelligence_pc/detail/trueDataFeedback/history',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 真实数据反馈-删除
export const delTrueDataFeedbackHistory: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/trueDataFeedback/historyDel',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 查看是否收藏
export const getFollowing: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/collection/query',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 设置收藏|取消收藏
export const setFollowing: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/collection/create',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 获取头部统一ID
export const getDetailCombinedIds: (payload: {
  entity_type: string;
  id: string;
  b_get_overLap_id: boolean;
}) => Promise<any> = (payload) => {
  const url = '/api/v1/intelligence_pc/detail/combined_ids';

  // 获取pc console聚合页统一ID ---已不需要区分接口
  // if (payload?.entity_type === PC_CONSOLE_COMBINE_ENTITY_TYPE) {
  //   url = '/api/v1/intelligence_pc/pcConsoleGame/detail/combined_ids';
  // }
  return http({
    url,
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 获取单游戏详情-新mobile接口
export const getSingleGameDetailMobile: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/game/overview/about', // 新bigquery-mobile接口
    // url: '/api/v1/intelligence_pc/detail/single/about',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 获取单游戏详情
export const getSingleGameDetail: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/single/about',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 获取卡片数据
export const getDetailIndex: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/mobile/overview/summary', // 新bigquery-mobile接口
    // url: '/api/v1/intelligence_pc/detail/overview/summary',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 获取卡片数据（pc、console联合游戏详情页）
export const getDetailIndexCombine: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/game/overview/summary',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 获取USRevenueUnits卡片数据
export const fetchUSRevenueUnits: (payload: any, config: any) => Promise<any> = (payload, config) => {
  return http({
    url: '/api/v1/intelligence_pc/overview/kpi_us_revenue_and_units',
    method: 'post',
    data: payload,
    rawData: true,
    ...config,
  }) as Promise<any>;
};

// 获取DatabrainRevenueUnits卡片数据
export const fetchDatabrainRevenueUnits: (payload: any, config: any) => Promise<any> = (payload, config) => {
  return http({
    url: '/api/v1/intelligence_pc/overview/kpi_databrain_revenue_and_units',
    method: 'post',
    data: payload,
    rawData: true,
    ...config,
  }) as Promise<any>;
};

// 获取Engagement卡片数据
export const fetchEngagementData: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/game/overview/engagement',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 获取SteamData卡片数据
export const fetchSteamCardData: (payload: any, config: any) => Promise<any> = (payload, config) => {
  return http({
    url: '/api/v1/intelligence_pc/game/overview/steam',
    method: 'post',
    data: payload,
    rawData: true,
    ...config,
  }) as Promise<any>;
};

// 获取Streaming卡片数据
export const fetchStreamingCardData: (payload: any, config: any) => Promise<any> = (payload, config) => {
  return http({
    url: '/api/v1/intelligence_pc/game/overview/streaming',
    method: 'post',
    data: payload,
    rawData: true,
    ...config,
  }) as Promise<any>;
};

// // 获取卡片数据里的Rank数据
// export const getDetailIndexRank: (payload: any) => Promise<any> = (payload) => {
//   return http({
//     url: '/api/v1/intelligence_pc/detail/overview/summary_rank',
//     method: 'post',
//     data: payload,
//     rawData: true,
//   }) as Promise<any>;
// };

// 获取卡片数据里的Rank数据（pc、console联合游戏详情页）
export const getDetailIndexRankCombine: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/game/overview/summary_rank',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getMobileDetailIndexRank: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/mobile/overview/summary_rank', // 新bigquery-mobile接口
    // url: '/api/v1/intelligence_pc/detail/overview/mobile/summary_rank',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 获取appid游戏列表详情
export const getEditionList: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/mobile/overview/edition_list', // 新bigquery-mobile接口
    // url: '/api/v1/intelligence_pc/detail/edition_list',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 获取游戏详情Stream-Trends
export const getStreamTrends: (payload: any, entityType: string) => Promise<any> = (payload, entityType) => {
  let url = '/api/v1/intelligence_pc/detail/stats/stream/trends';

  if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE) {
    url = '/api/v1/intelligence_pc/pcConsoleGame/detail/stats/stream/trends';
  }
  return http({
    url, // '/api/v1/intelligence_pc/detail/stats/stream/trends',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 获取游戏详情channel_share-table
export const getStreamChannelShareTable: (payload: any, entityType: string) => Promise<any> = (payload, entityType) => {
  let url = '/api/v1/intelligence_pc/detail/stats/stream/channel_share';

  if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE) {
    url = '/api/v1/intelligence_pc/pcConsoleGame/detail/stats/stream/channel_share';
  }
  return http({
    url, // '/api/v1/intelligence_pc/detail/stats/stream/channel_share',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 获取游戏详情Stream-channel_share_trends
export const getStreamChannelShareTrends: (payload: any, entityType: string) => Promise<any> = (
  payload,
  entityType,
) => {
  let url = '/api/v1/intelligence_pc/detail/stats/stream/channel_share_trends';

  if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE) {
    url = '/api/v1/intelligence_pc/pcConsoleGame/detail/stats/stream/channel_share_trends';
  }
  return http({
    url, // '/api/v1/intelligence_pc/detail/stats/stream/channel_share_trends',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

/**
 * 兼容：当请求参数中存在 vginsights 的 metric_filter 时，同时补齐 gamalytic 的同指标过滤。
 * gamalytic 指标命名使用 `gamalytic__` 前缀。
 *
 * 说明：该逻辑仅在榜单相关接口请求前处理，避免影响其他不支持 gamalytic 的接口。
 */
const patchTopChartsMetricFilterPayload = (payload: any): any => {
  if (!payload || typeof payload !== 'object') return payload;
  const metricFilter = payload?.metric_filter;
  if (!metricFilter || typeof metricFilter !== 'object') return payload;

  const hasVginsightsKey = Object.prototype.hasOwnProperty.call(metricFilter, 'vginsights');
  if (!hasVginsightsKey) return payload;

  const vginsights = (metricFilter as any)?.vginsights;

  const prev = Array.isArray((metricFilter as any)?.gamalytic) ? (metricFilter as any).gamalytic : [];

  // vginsights 为空数组时，也需要补齐 gamalytic: []
  let gamalytic = prev;

  if (Array.isArray(vginsights) && vginsights.length > 0) {
    const toGamalyticMetric = (metric: unknown) => {
      if (typeof metric !== 'string' || !metric) return metric;
      return metric.startsWith('gamalytic__') ? metric : `gamalytic__${metric}`;
    };

    const mapped = vginsights
      .map((item: any) => ({
        ...item,
        metric: toGamalyticMetric(item?.metric),
      }))
      .filter((item: any) => typeof item?.metric === 'string' && item.metric);

    const merged = [...prev, ...mapped];

    // 去重：按 metric + opt + value + ratio_type
    const seen = new Set<string>();
    gamalytic = merged.filter((item: any) => {
      const key = `${String(item?.metric)}|${String(item?.opt)}|${String(item?.value)}|${String(
        item?.ratio_type ?? '',
      )}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  return {
    ...payload,
    metric_filter: {
      ...(metricFilter as any),
      gamalytic,
    },
  };
};

/**
 * 处理异动指标参数
 * @param params - 接口入参
 * @return 接口入参
 */
export const formatSurgeMetricFetchParams = (params: IRecord): IRecord => {
  if (isEmpty(params)) {
    return {};
  }

  const { surge_metric: surgeMetric, ...restParams } = params;
  const validSurgeMetric = getValidSurgeMetric(surgeMetric, restParams?.source_metrics);

  if (isEmpty(validSurgeMetric)) {
    return restParams;
  }

  const rotationOrderBy = getSurgeMetricRotationOrderBy(validSurgeMetric);

  if (!rotationOrderBy) {
    return restParams;
  }

  return {
    ...restParams,
    rotation_order_by: rotationOrderBy,
  };
};

export const getMetricsTableDataRankList: (payload: any, config?: { [key: string]: any }) => Promise<any> = (
  payload,
  config,
) => {
  return http({
    // url: '/api/v1/intelligence_pc/pcTopChartsMetricsTableRankList',
    ...config,
    url: '/api/v1/intelligence_pc/pcTopChartsMetricsTableRankListNew', // 替换新接口
    method: 'post',
    data: patchTopChartsMetricFilterPayload({
      date_type: 'monthly',
      regions: ['global'],
      ...payload,
      // 兜底为 market：payload 中 region_type 为 undefined/null 时会覆盖默认值，导致请求体丢失该字段
      region_type: payload?.region_type || 'market',
    }),
    rawData: true,
  }) as Promise<any>;
};

export const getMetricsTableDataTrends: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/pcTopChartsMetricsTableTrendNew',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getPCConsoleMetricsTableDataRankList: (payload: any, config?: { [key: string]: any }) => Promise<any> = (
  payload,
  config,
) => {
  return http({
    ...config,
    url: '/api/v1/intelligence_pc/pcTopChartsMetricsTableRankListNew',
    method: 'post',
    data: patchTopChartsMetricFilterPayload({
      date_type: 'monthly',
      regions: ['global'],
      ...payload,
      // 兜底为 market：payload 中 region_type 为 undefined/null 时会覆盖默认值，导致请求体丢失该字段
      region_type: payload?.region_type || 'market',
    }),
    rawData: true,
    errorHandler: true, // 筛选条件会出现所有指标都禁用的情况，导致参数错误，这个提示先禁掉
  }) as Promise<any>;
};

// 全新预处理榜单统一接口
export const fetchCommonTopChartsList: (payload: any, config?: { [key: string]: any }) => Promise<any> = (
  payload,
  config,
) => {
  return http({
    ...config,
    url: '/api/v1/intelligence_pc/topcharts_list',
    method: 'post',
    data: formatSurgeMetricFetchParams(
      normalizePcConsoleTopChartsApiPayload(patchTopChartsMetricFilterPayload(payload)),
    ),
    rawData: true,
    errorHandler: true, // 筛选条件会出现所有指标都禁用的情况，导致参数错误，这个提示先禁掉
  }) as Promise<any>;
};

export const getPCConsoleMetricsTableDataTrends: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/pcTopChartsMetricsTableTrendNew',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getStudioCompetitorTableDataRankList: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/homepage/pc/StudioHubCompetitorTable',
    method: 'post',
    data: payload,
    rawData: true,
    errorHandler: true, // 筛选条件会出现所有指标都禁用的情况，导致参数错误，这个提示先禁掉
  }) as Promise<any>;
};

export const getStudioCompetitorMetricsTableDataTrends: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/homepage/pc/StudioHubCompetitorTrend',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchCompaniesRanksData = (params: any, config?: { [key: string]: any }): Promise<any> => {
  return http({
    // url: '/api/v1/intelligence_pc/pcTopchartsCompanyRankTable',
    ...config,
    url: '/api/v1/intelligence_pc/pcTopchartsCompanyTable',
    method: 'post',
    data: params,
    rawData: true,
  }) as Promise<any>;
};

export const fetchCompaniesTrendsData = (params: any): Promise<any> => {
  return http({
    // url: '/api/v1/intelligence_pc/pcTopchartsCompanyTrends',
    url: '/api/v1/intelligence_pc/pcTopchartsCompanyTrend',
    method: 'post',
    data: params,
    rawData: true,
  }) as Promise<any>;
};

export const fetchCompaniesNewsActivityData = (params: {
  company_id: string;
  entity_type: string;
  page: number;
  page_size: number;
}): Promise<{
  code: number;
  data: {
    activities: {
      activity: string;
      activity_type: string;
      announced_on: string;
    }[];
    game_list: {
      app_id: string;
      array_genre: string[];
      cover: string;
      entity_type: string;
      eu_id: string;
      name: string;
      potential: string;
      release_time: string;
      source: string;
    }[];
    highlight_charts: any; // 数据个数不知道，页面都没数据
    media_news: any; // 数据个数不知道，页面都没数据
    total_num: string;
  };
  msg: string;
  req: {
    company_id: string;
    entity_type: string;
    page: number;
    page_size: number;
  };
}> => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/newactivity',
    method: 'post',
    data: params,
    rawData: true,
  }) as Promise<any>;
};

export const fetchCompaniesNewsActivityFullNameData = (params: {
  company_id: string;
  entity_type: string;
}): Promise<{
  company_name: string[];
}> => {
  return http({
    url: '/api/v1/intelligence_pc/detail/company/newactivity/viewMore',
    method: 'post',
    data: params,
    rawData: false,
  }) as Promise<any>;
};

export const statsNewzooTrend: (payload: any) => Promise<any> = (payload) => {
  const params = { ...payload, adjust_metric: payload?.adjust_metric ?? true };
  return http({
    url: '/api/v1/intelligence_pc/pcConsoleGame/detail/stats/newzoo/trend',
    method: 'post',
    data: params,
    rawData: true,
  }) as Promise<any>;
};

export const statsNewzooMarketTable: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/pcConsoleGame/detail/stats/newzoo/market',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const statsNewzooMarketTrend: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/pcConsoleGame/detail/countries/newzoo/trends',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const statsSteamSalesTrend: (payload: any) => Promise<any> = (payload) => {
  // 处理 gamalytic_ 前缀的 metrics 参数转换
  const processedPayload = { ...payload };
  // 处理 metrics 数组字段
  if (Array.isArray(processedPayload.metrics)) {
    const gamalyticMetrics = processedPayload.metrics.filter((m: string) => m?.startsWith('gamalytic_'));
    if (gamalyticMetrics.length > 0) {
      processedPayload.data_sources = ['gamalytic'];
    }
  }
  return http({
    url: '/api/v1/intelligence_pc/pcConsoleGame/detail/stats/steam/salesTrend',
    method: 'post',
    data: processedPayload,
    rawData: true,
  }) as Promise<any>;
};

export const statsSteamSalesMarket: (payload: any) => Promise<any> = (payload) => {
  // 处理 gamalytic_ 前缀的 metrics 参数转换
  const processedPayload = { ...payload };
  // 处理 metrics 数组字段
  if (Array.isArray(processedPayload.metrics)) {
    const gamalyticMetrics = processedPayload.metrics.filter((m: string) => m?.startsWith('gamalytic_'));
    if (gamalyticMetrics.length > 0) {
      processedPayload.data_sources = ['gamalytic'];
    }
  }
  return http({
    url: '/api/v1/intelligence_pc/pcConsoleGame/detail/countries/steam/salesMarket',
    method: 'post',
    data: processedPayload,
    rawData: true,
  }) as Promise<any>;
};

export const statsJapanSalesTrend: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/pcConsoleGame/detail/stats/jpnSalesTrend',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const statsJapanSalesMarket: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/pcConsoleGame/detail/countries/jpnSalesMarket',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const statsPCUTrend: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/pcConsoleGame/detail/stats/pcu/trend',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const statsTrend: (payload: any) => Promise<any> = (payload) => {
  const params = { ...payload, adjust_metric: payload?.adjust_metric ?? true };
  return http({
    url: '/api/v1/intelligence_pc/pcConsoleGame/detail/stats/trend',
    method: 'post',
    data: params,
    rawData: true,
  }) as Promise<any>;
};
export const statsGSDTrend: (payload: any) => Promise<any> = (payload) => {
  const params = { ...payload, adjust_metric: payload?.adjust_metric ?? true };
  return http({
    url: '/api/v1/intelligence_pc/pcConsoleGames/detail/stats/trend',
    method: 'post',
    data: params,
    rawData: true,
  }) as Promise<any>;
};

export const statsPCUMarketTable: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/pcConsoleGame/detail/stats/pcu/countriesTable',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const statsCountriesTable: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/pcConsoleGame/detail/stats/countriesTable',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const statsPCUMarketTrend: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/pcConsoleGame/detail/stats/pcu/countriesTrend',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const statsCountriesTrend: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/pcConsoleGame/detail/stats/countriesTrend',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};
export const getjpnSalesTimeRange: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/stats/jpnSalesTimeRange',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getDemographics: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/demographics',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const getDemographicsNew: (payload: any) => Promise<any> = (payload) => {
  if(payload.granularity === 'quarterly' && payload.end_date) {
    // 季度特殊处理 结束日期等于开始日期
    payload.end_date = payload.start_date;
  }
  return http({
    url: '/api/v1/intelligence_pc/game/mobile/demographic/metrics',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const pcTopchartsDemographicsRankList: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/pcTopChartDemographicsRankList',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const pcTopchartsDemographicsRankListDetail: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/pcTopChartDemographicsRankListDetail',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchConsoleJapanSalesRanks = (payload: any): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/pcTopChartsJapanSalesRankList',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchConsoleJapanSalesTrends = (payload: any): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/pcTopChartsJapanSalesTrend',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

export const fetchPCConsoleAllMetricsTrends = (payload: any, config?: any): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/pcConsoleGame/detail/stats/allMetrics/trend',
    method: 'post',
    data: payload,
    rawData: true,
    ...config,
  }) as Promise<any>;
};

export const fetchPCConsoleKPITrendsCharts = (payload: any): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/stat/all_metrics_trend_chart',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// PC&Console KPITrends 页面获取数据接口，同步使用 Compare PC&ConsoleBeta 页接口
export const fetchPCConsoleKPITrendsCompareTrends = (payload: any, config?: any): Promise<any> => {
  const params = { ...payload, adjust_metric: payload?.adjust_metric ?? true };
  return http({
    url: '/api/v1/intelligence_pc/compare/pcConsoleMetricData',
    method: 'post',
    data: normalizePcConsoleTopChartsApiPayload(params),
    rawData: true,
    ...config,
  }) as Promise<any>;
};

// 品类调整接口
export const updateGameGenres = (payload: {
  entity_type: IGameType;
  game_id: string;
  entity_name: string;
  genre: string;
  sub_genre: string;
  genre_new: string;
  sub_genre_new: string;
}): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/detail/stats/user_genre_opinions',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 获取游戏详情页Overlap页签的AppIds--mobile游戏  --- 此数据已转移至api/v1/intelligence_pc/detail/combined_ids接口
// export const fetchOverlapAppids = (payload: { app_ids: string[] }): IBaseResponse<{ appids: string[] }> => {
//   return http({
//     url: '/api/v1/intelligence_pc/detail/crossAppUsage/appIds',
//     method: 'post',
//     data: payload,
//     rawData: true,
//   }) as IBaseResponse<{ appids: string[] }>;
// };

// 获取游戏详情页Overlap页签的AppIds--steam游戏 --- 此数据已转移至api/v1/intelligence_pc/detail/combined_ids接口
// export const fetchOverlapSteamGameAppids = (payload: { id: string, entity_type: string }): IBaseResponse<{ id: string }> => {
//   return http({
//     url: '/api/v1/intelligence_pc/detail/steamOverlapGame/ids',
//     method: 'post',
//     data: payload,
//     rawData: true,
//   }) as IBaseResponse<{ id: string }>;
// };

/**
 * 获取游戏详情页GSD的多个options集合，包含以下options集合
 * 1、segment的options集合
 * 2、device的options集合
 * @returns 游戏详情页GSD的多个options集合，包含以下options集合
 */
export const fetchGSDOptions = (
  params = {},
): IBaseResponse<{
  segments: ICommonOption[];
  devices: ICommonOption[];
}> => {
  return http({
    url: '/api/v1/intelligence_pc/getGsdDeviceSegmentFilter',
    method: 'post',
    data: params,
    rawData: true,
  }) as IBaseResponse<{
    segments: ICommonOption[];
    devices: ICommonOption[];
  }>;
};
/**
 * kpiOverview-time-spent-playing 接口
 */
// 获取Engagement卡片数据
export const timeSpentPlaying: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/overview/kpi_time_spent_playing',
    method: 'post',
    data: payload,
    interfaceCache: false,
  }) as Promise<any>;
};
/**
 * kpiOverview-time-spent-playing 接口
 */
// 获取Engagement卡片数据
export const steamCountiesPlayer: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/overview/kpi_players_by_country',
    method: 'post',
    data: payload,
    interfaceCache: false,
  }) as Promise<any>;
};
/**
 * kpiOverview-time-spent-playing 接口
 */
// 获取Engagement卡片数据
export const steamKpiPlaytime: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/overview/kpi_playtime',
    method: 'post',
    data: payload,
    interfaceCache: false,
  }) as Promise<any>;
};
/**
 * kpiOverview-all-reviews 接口
 */
// 获取Engagement卡片数据
export const getSteamStats: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/opinion_pc/global/steam_stats',
    method: 'post',
    data: payload,
  }) as Promise<any>;
};
/**
 * kpiOverview-public_data_collection 接口
 */
// 获取外部公开数据宽表接口
export const getPublicDataCollection: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/overview/kpi_public_data_collection',
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

/**
 * PC&Console GameInfo 获取 Steam New & Announcements 数据接口
 */
export const getSteamNewAndAnnouncements: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/detail/game_steam_news',
    method: 'post',
    data: payload,
  }) as Promise<any>;
};
